import { lawsuitRedistributionDepartments } from '@/helpers/enum';
import { apiModule } from '@/helpers/utils';
import axios from 'axios';

const requestPrefix = process.env.VUE_APP_MODULE_REQUESTS;
const lawsuitRequestPrefix = `${process.env.VUE_APP_MODULE_REQUESTS}/lawsuit-requests`;
const lawsuitReportsPrefix = `${process.env.VUE_APP_MODULE_REQUESTS}/lawsuit-reports`;
const casesDigitizationPrefix = `${process.env.VUE_APP_MODULE_REQUESTS}/cases-digitization`;
const icmsPrefix = `${apiModule.ICMS}`;
const casesPrefix = `${process.env.VUE_APP_MODULE_CASES}/cases`;
const administrationPrefix = process.env.VUE_APP_MODULE_ADMINISTRATION;
const casesRelatedRequestsPrefix = apiModule.CASES_REQUESTS;
const systemPrefix = `${apiModule.SYSTEM}`;
const lawsuitReportPrefix = `${apiModule.REQUESTS}/lawsuit-reports`;
const paging = {
  pageSize: 10,
  pageIndex: 0,
};
const CancelToken = axios.CancelToken;
const cancelRequests = {};
export default {
  assignLawsuitRequest: requestObjectKey =>
    axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/assignments`),
  getLawsuitRequestInfo: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/simple-info`),
  getLawsuitCaseReport: caseObjectKey =>
    axios.get(`${casesPrefix}/${caseObjectKey}/reports/lawsuit`),
  getPortalLawsuitReport: ({ objectKey }) =>
    axios.get(`${lawsuitReportPrefix}/${objectKey}/reports/lawsuit`),
  getCourtAndSubCircleByJudgementCode: judgmentNumber =>
    axios.get(`${icmsPrefix}/judgements/${judgmentNumber}/issued-courts`),
  getLawsuitCase: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/subject`),
  updateLawsuitCase: (requestObjectKey, caseObject) =>
    axios.put(`${lawsuitRequestPrefix}/${requestObjectKey}/subject`, caseObject),
  getLawsuitCaseParties: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties`),
  submitLawsuit: lawsuitRequest => axios.post(`${lawsuitRequestPrefix}`, lawsuitRequest),
  checkPartyAuthentication: heirs =>
    axios.post(`${lawsuitRequestPrefix}/check-party-authentication`, heirs),
  changeRequestApplicant: (requestObjectKey, casePartyObjectKey) =>
    axios.patch(
      `${lawsuitRequestPrefix}/${requestObjectKey}/case-parties/${casePartyObjectKey}/applicant`
    ),
  addCaseParty: (requestObjectKey, caseParty) =>
    axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties`, caseParty),
  addMultipleCaseParties: (requestObjectKey, caseParties) =>
    axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties/multiple`, caseParties),
  updateCaseParty: (requestObjectKey, caseParty) =>
    axios.put(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties`, caseParty),
  removeCaseParty: (requestObjectKey, casePartyObjectKey) =>
    axios.delete(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties/${casePartyObjectKey}`),
  updatePartyAuthentication: payload => axios.put(`${lawsuitRequestPrefix}/${payload.objectKey}/party-authentication`, payload),
  uploadAttachment: (requestObjectKey, attachment) => {
    return axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/attachments`, {
      fileName: attachment.fileName,
      fileType: attachment.fileType,
      content: attachment.content, // base64
      fileCategory: attachment.fileCategory,
      extension: attachment.extension,
      sharePointId: attachment.sharePointId,
      isAttachmentAudited: attachment.isAttachmentAudited,
      isAttachmentVisible: attachment.isAttachmentVisible,
    });
  },
  detectAttachment: data => axios.post('http://104.214.221.105/document-detection-service/detections', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteAttachment: (requestObjectKey, attachmentObjectKey) =>
    axios.delete(`${lawsuitRequestPrefix}/${requestObjectKey}/attachments/${attachmentObjectKey}`),
  getLawsuitCaseAttachment: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/attachments`, { params: { pageSize: 200 } }),
  getJudgementDocumentByCaseCodeAndCaseYear: payload =>
    axios.get(`${icmsPrefix}/cases/${payload.caseCode}/${payload.caseYear}/judgement`),
  getJudgementDocumentByCode: payload =>
    axios.get(`${icmsPrefix}/cases/judgement/${payload.judgementCode}`),

  getJudgementDocumentByCodeCaseCodePartyIdentity: ({ caseCode, judgementCode, identityNumber }) =>
    axios.get(`${icmsPrefix}/cases/{encrypt:caseCode}/judgement/{encrypt:judgementCode}/party/{encrypt:identityNumber}`, {
      encryptParams: {
        caseCode,
        judgementCode,
        identityNumber,
      },
    }),

  getJudicialInformingDecision: payload =>
    axios.get(`${systemPrefix}/JudicialInformingDecision?identityType=${payload.identityType}&identityNumber=${payload.identityNumber}&requestCode=${payload.requestCode}`),
  getTrustedSourceAttachment: documentId => axios.get(`${systemPrefix}/SharePoint/trusted-source/documents?documentId=${documentId}`),
  getAttachmentURL: (requestObjectKey, attachmentObjectKey) =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/attachments/${attachmentObjectKey}`),
  getCaseMovementReplyTypes: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/actions`),
  submitCaseReply: (requestObjectKey, reply) =>
    axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/replies`, reply),
  checkCaseInfoByCaseCode: payload =>
    axios.get(`${icmsPrefix}/cases/${payload.caseCode}/${payload.caseYear}/${payload.socialId}/similar-case`),
  submitLawsuitRedistribution: payload =>
    axios.patch(
      `${lawsuitRequestPrefix}/${lawsuitRedistributionDepartments.lawsuit.id}/redistributions`,
      payload
    ),
  submitServicesCenterRedistribution: payload =>
    axios.patch(
      `${lawsuitRequestPrefix}/${lawsuitRedistributionDepartments.servicesCenter.id}/redistributions`,
      payload
    ),
  changeAuditPaths: payload => axios.patch(`${lawsuitRequestPrefix}/audit-paths`, payload),
  submitCentralAuditRedistribution: payload =>
    axios.patch(
      `${lawsuitRequestPrefix}/${lawsuitRedistributionDepartments.centralAudit.id}/redistributions`,
      payload
    ),
  getDistributionTicket: requestObjectKey =>
    axios.get(`${casesPrefix}/${requestObjectKey}/reports/distribution-ticket`),
  getSimilarCases: (payload) => {
    cancelRequests.getSimilarCases && cancelRequests.getSimilarCases();
    return axios.get(`${lawsuitRequestPrefix}/${payload.requestObjectKey}/similar-cases?`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getSimilarCases = cancelFunction;
      }),
      params: {
        pageSize: payload.params.pageSize || paging.pageSize,
        pageIndex: payload.params.pageIndex || paging.pageIndex,
      },
    });
  },
  getSimilarReconciliationRequests: (payload) => {
    cancelRequests.getSimilarReconciliationRequests &&
      cancelRequests.getSimilarReconciliationRequests();
    return axios.get(`${lawsuitRequestPrefix}/${payload.requestObjectKey}/similar-reconciliation-requests?`,
      {
        cancelToken: new CancelToken(function executor(cancelFunction) {
          // an executor function receives a cancel function as a parameter
          cancelRequests.getSimilarReconciliationRequests = cancelFunction;
        }),
        params: {
          pageSize: payload.params.pageSize || paging.pageSize,
          pageIndex: payload.params.pageIndex || paging.pageIndex,
        },
      }
    );
  },
  getRelatedCases: (payload) => {
    cancelRequests.getRelatedCases && cancelRequests.getRelatedCases();
    return axios.get(`${lawsuitRequestPrefix}/${payload.requestObjectKey}/related-cases`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getRelatedCases = cancelFunction;
      }),
      params: {
        pageSize: payload.params.pageSize || paging.pageSize,
        pageIndex: payload.params.pageIndex || paging.pageIndex,
      },
    });
  },
  addRelatedCases: payload =>
    axios.post(
      `${lawsuitRequestPrefix}/${payload.requestObjectKey}/related-cases`,
      payload.requestBody
    ),
  removeRelatedCases: ({
    requestObjectKey,
    relatedCaseObjectKey,
  }) =>
    axios.delete(
      `${lawsuitRequestPrefix}/${requestObjectKey}/related-cases/${relatedCaseObjectKey}`
    ),
  getCasePreviousReplies: requestObjectKey =>
    axios.get(`${casesRelatedRequestsPrefix}/cases-related-requests/${requestObjectKey}/actions`),
  getPortalCasePreviousReplies: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/tracking`),
  getAuditFields: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/audit-fields`),
  updateAuditFields: ({
    payload,
    requestObjectKey,
  }) =>
    axios.put(`${lawsuitRequestPrefix}/${requestObjectKey}/audit-fields`, payload),
  getReviewTicket: payload =>
    axios.get(`${lawsuitReportsPrefix}/${payload.requestObjectKey}/review-ticket` + (payload.forPartyAuthentications ? '?forPartyAuthentications=true' : ''), { overrideErrorHandlingBehaviour: true }),
  getRequiredAttachments: caseTypeId =>
    axios.get(`${requestPrefix}/attachments/required-attachments?caseTypeId=${caseTypeId}`),
  getRequiredAttachmentsByRequestObjectKey: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/required-attachments`),
  getAttachmentTypesByRequestObjectKey: requestObjectKey =>
    axios.get(`${lawsuitRequestPrefix}/${requestObjectKey}/attachments-types`),
  updateRequestAttachmentAuditField: ({
    requestAttachmentObjectKey,
    isAttachmentAudited,
  }) =>
    axios.put(`${lawsuitRequestPrefix}/${requestAttachmentObjectKey}/request-attachment-audit-field/${isAttachmentAudited}`),
  getPartiesClosestCourts: payload =>
    axios.post(`${administrationPrefix}/courts/parties-closest-courts?specializationRule=${payload.disableLocationSpecializationRule}`, payload),
  getExecutionCourts: payload =>
    axios.get(`${administrationPrefix}/courts/${payload}/execution-courts`),
  searchCasesTypes: (payload) => {
    cancelRequests.searchCasesTypes && cancelRequests.searchCasesTypes();
    return axios.get(`${administrationPrefix}/cases-types/search?keyword=${payload}`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.searchCasesTypes = cancelFunction;
      }),
    });
  },
  getSimilarRequests: (payload) => {
    cancelRequests.getSimilarRequests && cancelRequests.getSimilarRequests();
    return axios.get(`${lawsuitRequestPrefix}/${payload.requestObjectKey}/similar-requests?`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        // an executor function receives a cancel function as a parameter
        cancelRequests.getSimilarRequests = cancelFunction;
      }),
      params: {
        pageSize: payload.params.pageSize || paging.pageSize,
        pageIndex: payload.params.pageIndex || paging.pageIndex,
      },
    });
  },
  getUpcomingSessions: () =>
    axios.get(`/ocelot/api/upcoming-sessions`),

  getSessionsRange: ({
    dateFrom,
    dateTo,
  }) =>
    axios.get(`/ocelot/api/my-sessions-range?dateFrom=${dateFrom}&dateTo=${dateTo}`),

  getMyRequests: (payload) => {
    cancelRequests.getMyRequests && cancelRequests.getMyRequests();
    return axios.get(`/ocelot/api/my-requests`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMyRequests = cancelFunction;
      }),
      params: payload,
    });
  },
  getMyLegacyCaseDigitizationRequest: (payload) => {
    cancelRequests.getMyLegacyCaseDigitizationRequest && cancelRequests.getMyLegacyCaseDigitizationRequest();
    return axios.get(`${casesDigitizationPrefix}/my-requests`, {
      cancelToken: new CancelToken(function executor(cancelFunction) {
        cancelRequests.getMyLegacyCaseDigitizationRequest = cancelFunction;
      }),
      params: payload,
    });
  },
  checkMarriageDeeds: payload => axios.get(`${systemPrefix}/Moi/marriage-deeds?husbandNationalId=${payload.husbandNationalId}&wifeNationalId=${payload.wifeNationalId}`),
  getPartyExecutionRequests: payload => axios.get(`${systemPrefix}/execution/${payload.executionIdentityType}/identityType/${payload.executionIdentityId}/identityId`),
  getRequestsFeesEstimation: payload => axios.post(`${lawsuitRequestPrefix}/fees-estimation`, payload),
  addCasesDigitizationRequest: payload => axios.post(`${casesDigitizationPrefix}`, payload),
  getArbitrationAward: requestCode => axios.get(`${lawsuitRequestPrefix}/${requestCode}/Arbitration`),
  getJudgementSections: params => axios.get(`${icmsPrefix}/judgements/${params.judgementCode}/${params.caseCode}/sections`),
  getJudgementDeeds: payload => axios.get(`${icmsPrefix}/deeds/inquiries?CourtId=${payload.courtId}&CaseCode=${payload.caseCode}&JudgmentCode=${payload.judgmentCode}&PartyIdentityTypeId=${payload.partyIdentityTypeId}&PartyIdentityId=${payload.partyIdentityId}&PartyCaseRoleId=${payload.partyCaseRoleId}&InquireSocialTypeId=${payload.inquireSocialTypeId}&InquireSocialId=${payload.inquireSocialId}&InquireMobileNo=${payload.inquireMobileNo}&SystemCode=${payload.systemCode}`),
  // صفات الاطراف
  getActivePartyAttributes: ({ caseTypeId, partyTypeId, partyRoleId, legalPositionId }) => {
    let url = `${requestPrefix}/party-attributes/active?`;
    if (caseTypeId != null) url += `caseTypeId=${caseTypeId}`;
    if (partyTypeId != null) url += `&partyTypeId=${partyTypeId}`;
    if (partyRoleId != null) url += `&partyRoleId=${partyRoleId}`;
    if (legalPositionId != null) url += `&legalPositionId=${legalPositionId}`;

    return axios.get(url);
  },
  getPartyAttributesBasicInfo: () => axios.get(`${requestPrefix}/party-attributes/basic-info`),
  // remove case parties for draft case when caseType changed
  deleteCasePartiesByObjectKeys: (requestObjectKey, objectKeys) =>
    axios.post(`${lawsuitRequestPrefix}/${requestObjectKey}/case-parties/delete-case-parties-by-objectKeys`, objectKeys),
  getIncomingRequests: payload => axios.get(`${casesRelatedRequestsPrefix}/my-incoming-requests`, { params: payload }),
  userHasIncomingRequests: () => axios.get(`${casesRelatedRequestsPrefix}/cases/user-has-incoming-requests`),

};